import styled from '@emotion/styled';

export const StyledNewsletter = styled.div`
  background: linear-gradient(
    180deg,
    rgba(7, 10, 30, 0.2) 0%,
    rgba(7, 10, 30, 0) 34.38%,
    rgba(7, 10, 30, 0) 64.58%,
    rgba(7, 10, 30, 0.2) 100%
  );
  border: 1px solid #2addba;
  padding: 48px 24px;
  width: 100%;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: 32px 64px;
  }
`;
